// extracted by mini-css-extract-plugin
export var content = "_4j-3";
export var list = "_4j-4";
export var settingsContent = "_4j-7";
export var settingsPanel = "_4j-8";
export var state = "_4j-6";
export var triggerBadge = "_4j-2";
export var triggerButton = "_4j-1";
export var triggerShell = "_4j-0";
export var unreadDot = "_4j-5";